import { Grid, Typography } from "@mui/material";

import NodePath from "domains/nodes/components/node-path/NodePath";
import localisations from "../../../localisation";

function ConfirmationStage(props: any) {
    const {
        heading,
        blurb,
        partitionParent,
        partitionName,
        productName,
        quantityChange,
        productDescription,
        notes } = localisations.createPartition.stages.confirmation;
    const fields = props.fields;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>
            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>
            <br />
            <Grid>
                <Typography>{partitionName}: {fields.partitionDetails?.name}</Typography>
                <Typography display="inline">{partitionParent}: </Typography>
                <NodePath
                    textDisplay="inline"
                    showAsText={true}
                    nodeId={fields.partitionDetails?.partitionParentId}
                />
                <Typography>{productName}: {fields.productDetails?.sku}</Typography>
                <Typography>{productDescription}: {fields.productDetails?.description}</Typography>
                <Typography>{quantityChange}: {fields.quantityChange}</Typography>
                <Typography>{notes}: {fields.notes}</Typography>
            </Grid>
        </>
    );
}

export default ConfirmationStage;
